import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faFacebookF } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer className="w-full bg-beige/50 py-6 font-para">
      <div className="container mx-auto flex flex-row items-center justify-center gap-16 md:gap-40 lg:gap-60 px-6 sm:px-10">
        {/* Left Section */}
        <div className="flex flex-col">
          {/* Logo */}
          <div className="mx-auto">
            <img
              src="/images/logo.png"
              alt="logo"
              className="md:w-24 lg:w-28 w-20"
            />
            {/* Social Icons */}
            <div className="flex gap-3 mt-2 justify-center">
              <FontAwesomeIcon
                icon={faInstagram}
                className="w-5 h-5 max-sm:w-4 max-sm:h-4 p-2 max-sm:p-1 text-beige bg-brown-600 rounded-full cursor-pointer hover:scale-105 transition duration-300"
                onClick={() =>
                  window.open("https://www.instagram.com/sandhyamulchandaniart", "_blank")
                }
              />
              <FontAwesomeIcon
                icon={faFacebookF}
                className="w-5 h-5 max-sm:w-4 max-sm:h-4 p-2 max-sm:p-1 text-beige bg-brown-600 rounded-full cursor-pointer hover:scale-105 transition duration-300"
                onClick={() =>
                  window.open("https://www.facebook.com/sandhyamulchandaniart/", "_blank")
                }
              />
            </div>
          </div>

        </div>

        {/* Right Section */}
        <div className="flex flex-col items-start text-left">

          {/* Contact Info */}
          <div className="text-lg max-md:text-base max-sm:text-sm text-brown-700">
            <p className="font-semibold">Sandhya Mulchandani</p>
            <p>tvisarts@gmail.com</p>
            <p>+61 437172647</p>
            <p>
              43, Phillis Street, Maylands,
              <br />
              Adelaide, SA-5069
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;